import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const ANNEXI_ENDPOINTS = {
  get_annexi_by_campaign_member: (id_campaign, id_member) => `${BASE_URL}api/annexi/${id_campaign}/${id_member}`,
  create_annexi: `${BASE_URL}api/annexi/`,
  download_annexi: (campaign_id, member_id) =>
    `${BASE_URL}api/annexi/${campaign_id}/${member_id}/annexei/download`,
};

class AnnexI {
  async getAnnexIByCampaignMember(id_campaign, id_member) {
    const { data } = await request({
      url: ANNEXI_ENDPOINTS.get_annexi_by_campaign_member(id_campaign, id_member),
    });
    return data;
  }

  async createAnnexi(payload){
    return await request({
      url: ANNEXI_ENDPOINTS.create_annexi,
      method: "POST",
      body: payload,
    });
  }
}

export const AnnexIService = new AnnexI();
